import React from 'react';
import { motion } from 'framer-motion';

const includes = [
    'Preparación estratégica (diagnóstico, workshops, diseño)',
    'Gestión de agenda comercial y contactos calificados',
    'Registro FITUR, acreditación y config. LiveConnect',
    'Acompañamiento especializado continuo',
    'Cena de bienvenida con la Tribu',
    'Seguimiento post-feria (Fase 3)',
];

const excludes = [
    'Boletos aéreos (usa tus millas o aerolínea preferida)',
    'Alojamiento y comidas no especificadas',
    'Seguro de viaje y gastos personales',
];

const Row = ({ text, kind }) => (
    <motion.li
        initial={{ opacity: 0, x: kind === 'yes' ? -20 : 20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.6 }}
        className="flex items-start gap-4 py-4 border-b border-white/10"
    >
        {kind === 'yes' ? (
            <span className="mt-1 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full border border-[color:var(--magenta)] text-[color:var(--magenta)]">
                ✓
            </span>
        ) : (
            <span className="mt-1 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full border border-white/25 text-white/50">
                ×
            </span>
        )}
        <span className={`text-base leading-relaxed ${kind === 'yes' ? 'text-white/90' : 'text-white/55'}`}>
            {text}
        </span>
    </motion.li>
);

const Includes = () => (
    <section id="incluye" className="relative py-16 md:py-24 border-t border-white/10 bg-[color:var(--surface)]">
        <div className="mx-auto max-w-[1440px] px-6 md:px-10">
            <div className="mb-10 max-w-3xl">
                <div className="overline mb-6">Transparencia absoluta</div>
                <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-[-0.02em]">
                    Qué incluye <span className="italic-accent text-[color:var(--brand)] font-normal">y qué controlas tú.</span>
                </h2>
            </div>
            <div className="grid grid-cols-12 gap-5 md:gap-8">
                <div className="col-span-12 md:col-span-6">
                    <div className="overline mb-4 text-[color:var(--magenta)]">Tu misión incluye</div>
                    <ul>
                        {includes.map((t, i) => (
                            <Row key={i} text={t} kind="yes" />
                        ))}
                    </ul>
                </div>
                <div className="col-span-12 md:col-span-5 md:col-start-8">
                    <div className="overline mb-4 text-white/60">Tú controlas</div>
                    <ul>
                        {excludes.map((t, i) => (
                            <Row key={i} text={t} kind="no" />
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    </section>
);

export default Includes;
